import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const navigate = useNavigate();

    return (
        <footer className="app-footer">
            <p>&copy; 2026 Collaboration World. All rights reserved.</p>
            <div className="footer-links">
                <button onClick={() => navigate('/')} className="footer-link">HOME</button>
                <span className="footer-divider">•</span>
                <button onClick={() => navigate('/about')} className="footer-link">ABOUT US</button>
                <span className="footer-divider">•</span>
                <button onClick={() => navigate('/services')} className="footer-link">SERVICES</button>
                <span className="footer-divider">•</span>
                <button onClick={() => navigate('/contact')} className="footer-link">CONTACT</button>
            </div>
            <div className="footer-social-links">
                <a href="https://wa.me/917838280563" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="WhatsApp">
                    <i className="ri-whatsapp-line"></i>
                </a>
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info.collaborationworld@gmail.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Email">
                    <i className="ri-mail-line"></i>
                </a>
                <a href="https://instagram.com/collaborationworld" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
                    <i className="ri-instagram-line"></i>
                </a>
            </div>
        </footer>
    );
};

export default Footer;
